<ul class="filters-users-subsection">
    <li *ngFor="let user of users | usersSortByName: 'asc'" (click)="onSelect(user)">
        <span class="filter-subtitle" [title]="user.email" [ngClass]="{longname:(user.name.length > 20)}">{{user.name}} <span *ngIf="user.email != user.name"><strong>(</strong><em >{{user.email}}</em><strong>)</strong></span>
        </span>
    </li>
</ul>
